export const TOKENKEY = 'xa_token'
export const MINIKEY = 'xa_mini'
export const ENTRYQUERYINFOKEY = 'entry-query-info-key'
export const IframeWrapWindowtHistoryKey = 'IframeWrapWindowtHistoryKey'
// 权限常量字段，同一个常量代表同一种，可用于判断统一种授权不需要重复获取
// 售后服务摄像机相关
export const USER_AFTERSALE_REPAIR_CAMERA_AUTH = 'USER_AFTERSALE_REPAIR_CAMERA_AUTH'
// 经纬度权限-售后服务找出最近网点相关
export const USER_AFTERSALE_REPAIR_NEARBY_WAREHOUSE_AUTH =
  'USER_AFTERSALE_REPAIR_NEARBY_WAREHOUSE_AUTH'
// 经纬度权限-查找附近网点相关
export const USER_NEARBY_WAREHOUSE_AUTH = 'USER_NEARBY_WAREHOUSE_AUTH'
// 经纬度权限-购买意外机损险相关
export const USER_JIJIA_INSURANCE_BUY_LOCATION_AUTH = 'USER_JIJIA_INSURANCE_BUY_LOCATION_AUTH'
// 农服打开小程序-获取用户授权相关
export const USER_OPEN_WX_MINIPROGRAME_AUTH = 'USER_OPEN_WX_MINIPROGRAME_AUTH'
